import { apiInterceptor } from 'utils/apiInterceptor';
export async function ImportSession(data, projectId) {
    const formData = new FormData();
    formData.append('file', data);

    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/sessions/import?projectId=${projectId}`,
        {
            method: 'POST',
            headers: {
            },
            body: formData,
        }
    );

    return await response.json();
}
